<script>
export default {
  name: "aside-messages-svg"
}
</script>

<template>
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2V8C13 9.125 12.0938 10 11 10H7L3.59375 11.9375C3.5 12 3.4375 12 3.375 12C3.15625 12 3 11.875 3 11.625V10H2C0.875 10 0 9.125 0 8V2C0 0.90625 0.875 0 2 0H11C12.0938 0 13 0.90625 13 2ZM4.5 9.71875L6.59375 8.5H11C11.25 8.5 11.5 8.28125 11.5 8V2C11.5 1.75 11.25 1.5 11 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V8C1.5 8.28125 1.71875 8.5 2 8.5H4.5V9.71875ZM8 12V11H9.5V12C9.5 12.2812 9.71875 12.5 10 12.5H13.375L15.5 13.7188V12.5H18C18.25 12.5 18.5 12.2812 18.5 12V6C18.5 5.75 18.25 5.5 18 5.5H14V4H18C19.0938 4 20 4.90625 20 6V12C20 13.125 19.0938 14 18 14H17V15.625C17 15.875 16.8125 16 16.625 16C16.5312 16 16.4688 16 16.375 15.9375L13 14H10C8.875 14 8 13.125 8 12Z" fill="#6C757D"/>
  </svg>
</template>

<style scoped>

</style>
